import { TablePaginationConfig } from "antd";
import { reportRequestsApi } from "api/reportRequest";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { IReportRequest } from "models/reportRequest";
import { ChangeEvent, useEffect, useState } from "react";

export default function useReportRequest() {
  const { showError } = useNotificationContext();
  const { reloadReportRequest } = useDataLoadingContext();
  const [data, setData] =
    useState<ITableData<IReportRequest>>(defaultTableData);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [data.page, data.search, reloadReportRequest]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await reportRequestsApi(
      data.page,
      data.per_page,
      data.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, handlePageChange, handleSearch };
}
